<template>
  <div class="content">
    <div class="hospital hp_flex">
      <div class="hospitalImg hp_center">
        <img
          v-if="hospitail.image"
          :src="base_url + hospitail.image"
          alt
        />
        <img
          v-else
          src="@/assets/default-img/hospital.png"
          alt
        />
      </div>
      <div class="detail">
        <div class="hp_cz_center">
          <span class="name">{{ hospitail.name }}</span>
          <a-rate
            style="color:#FF9C00;"
            disabled
            :value="hospitalCount.averageStar"
            allow-half
          />
        </div>
        <div class="tags hp_flex">
          <span
            v-if="hospitail.levelName"
            class="tag"
          >
            {{
            hospitail.levelName
            }}
          </span>
          <span
            v-if="hospitail.adminLevelName"
            class="tag"
          >
            {{
            hospitail.adminLevelName
            }}
          </span>
          <template v-if="hospitail.typeNames">
            <div
              v-for="(tag, index) in hospitail.typeNames.split(',')"
              :key="index"
              class="tag"
            >{{ tag }}</div>
          </template>
        </div>
        <div class="mobile hp_cz_center">
          <icon-font
            style="font-size:14px;"
            type="icon-dianhua01"
          />
          <span>{{ hospitail.tel }}</span>
        </div>
        <p class="mobile hp_cz_center">
          <icon-font
            style="font-size:14px;"
            type="icon-dingwei2"
          />
          <span>{{ hospitail.address }}</span>
        </p>
        <div class="more">
          <p>简介：{{hospitail.intro||'暂无简介'}}</p>
          <span
            @click="toment"
            v-if="hospitail && hospitail.id"
          >更多</span>
        </div>
      </div>

      <div
        class="attention hp_center"
        @click="attention"
      >
        <icon-font
          :class="{ active: hospitail.favorite }"
          type="icon-guanzhu1"
        />
        <span class="text-center-g">{{ hospitail.favorite ? '已关注' : '关注' }}</span>
      </div>
    </div>
    <div class="depts">
      <div class="title">挂号科室</div>
      <div
        v-if="hospitalDept && hospitalDept.length > 0"
        class="dept_name"
      >
        <a-row
          class="hp_flex"
          style="flex-wrap: wrap;"
        >
          <a-col
            v-for="(item, index) in hospitalDept"
            :key="index"
            :span="8"
          >
            <div
              style="width:96%;display:flex;"
              @click="toPage('/registered/dept/' + item.deptId)"
              class="hp_space_between"
            >
              <span style="width: 60%;">{{ item.deptName }}</span>
              <template v-if="item.doctorCount">
                <div class="people">（{{ item.doctorCount }}人）</div>
              </template>
              <div>
                <div
                  v-if="item.important"
                  class="tag"
                >{{ getImportantName(item.important) }}</div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <noData v-else></noData>
    </div>
    <div class="evaluate">
      <div class="title">
        患者评价
        <span v-if="totalCount">（{{ totalCount }}条）</span>
      </div>
      <template v-if="hospitalComment && hospitalComment.length > 0">
        <div
          class="evaluate_demo hp_flex"
          v-for="(item, index) in hospitalComment"
          :key="index"
        >
          <img
            v-if="item.avatar"
            class="photo"
            :src="base_url + item.avatar"
            alt
          />
          <img
            v-else
            class="photo"
            src="@/assets/default-img/r-doctor.png"
            alt
          />
          <div class="demo_right">
            <a-row>
              <a-col :span="8">科室：{{ item.deptName }}</a-col>
              <a-col :span="8">就诊医生：{{ item.doctorName }}</a-col>
              <a-col :span="8">评论时间：{{ item.createTime }}</a-col>
            </a-row>
            <template v-if="item.list[1]">
              <div class="hp_flex">
                <span>对医生的评价：</span>
                <a-rate
                  disabled
                  style="color:#FF9C00;"
                  :default-value="item.list[1].star"
                  allow-half
                />
                <div class="tags">
                  <a-tag
                    v-for="(tag, tagIndex) in strSplit(
                      item.list[1].content,
                      doctorDict,
                      0
                    )"
                    :key="tagIndex"
                    color="#FF9C00"
                  >{{ tag }}</a-tag>
                </div>
              </div>
              <div>{{ strSplit(item.list[1].content, hosDict, 1) }}</div>
            </template>
            <template v-if="item.list[0]">
              <div class="hp_flex">
                <span>对医院的评价：</span>
                <a-rate
                  disabled
                  style="color:#FF9C00;"
                  :default-value="item.list[0].star"
                  allow-half
                />
                <div class="tags">
                  <a-tag
                    v-for="(tag, tagIndex) in strSplit(
                      item.list[0].content,
                      hosDict,
                      0
                    )"
                    :key="tagIndex"
                    color="#FF9C00"
                  >{{ tag }}</a-tag>
                </div>
              </div>
              <div>{{ strSplit(item.list[0].content, hosDict, 1) }}</div>
            </template>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <a-pagination
            show-quick-jumper
            :current="currPage"
            :total="totalCount"
            :defaultPageSize="form.pageSize"
            @change="onChange"
          />
        </div>
      </template>
      <noData v-else></noData>
    </div>
  </div>
</template>
<script>
import {
  getHospitalDetail,
  getHospitalCount,
  getHospitalDept,
  getHospitalComment,
  getDict,
} from "@/api/registered";
import { cancelFavorite, submitFavorite } from "@/api/registered";
import { ls } from "@/utils/tool";
import noData from "@/components/NoData";
export default {
  components: {
    noData,
  },
  data() {
    return {
      id: this.$route.params.id,
      hospitail: {},
      hospitalCount: {},
      hospitalDept: [],
      hospitalComment: [],
      form: {
        hospitalId: this.$route.params.id,
        pageNum: 1,
        pageSize: 5,
      },
      currPage: 1,
      totalCount: 0,
      doctorDict: [],
      hosDict: [],
      sysUser: ls.get("sysUser"),
    };
  },
  created() {},
  mounted() {
    this.initHospital();
    this.initHospitalCount();
    this.initHospitalDept();
    this.initHospitalComment();
    this.initDict();
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    async initHospital() {
      var res = await getHospitalDetail(this.id);
      if (res.code == 200) this.hospitail = res.data;
      if (res.code == 500) {
        this.$message.error(res.message);
      }
    },
    async initHospitalCount() {
      var res = await getHospitalCount(this.id);
      this.hospitalCount = res.data;
    },
    async initHospitalDept() {
      var res = await getHospitalDept(this.id);
      this.hospitalDept = res.data;
      console.log(res.data);
    },
    async initHospitalComment() {
      var res = await getHospitalComment(this.form);
      this.hospitalComment = res.data.list;
      this.totalCount = res.data.totalCount;
      this.currPage = res.data.currPage;
    },
    onChange(pageNumber) {
      this.form.pageNum = pageNumber;
      this.initHospitalComment();
    },
    async initDict() {
      var list = [
        {
          type: "DOCTOR_IMPRESSION",
        },
        {
          type: "HOSP_IMPRESSION",
        },
      ];
      list.map(async (item) => {
        var res = await getDict(item);

        if (item.type == "DOCTOR_IMPRESSION") {
          this.doctorDict = res.data;
        }
        if (item.type == "HOSP_IMPRESSION") {
          this.hosDict = res.data;
        }
      });
    },
    strSplit(str, dict, num) {
      var arr = str.split("|||");
      var content = "";
      arr = arr.filter((item) => {
        var save = dict.some((d) => {
          return d.text == item;
        });
        if (save) {
          return item;
        } else {
          content = item;
        }
      });
      return !num ? arr || [] : content;
    },
    toment() {
      console.log(this.hospitail.id);
      this.$router.push("/registered/hosbrief/" + this.hospitail.id);
    },
    async attention() {
      console.log(this.hospitail);
      if (!this.sysUser) {
        this.$message.warning("请登录后再收藏!");
        this.$router.push("/login");
        return;
      }
      if (this.hospitail.favorite) {
        let res = await cancelFavorite({
          memberId: this.sysUser.id,
          objectId: this.hospitail.id,
          objectType: 1,
        });
        this.initHospital();
      } else {
        let res = await submitFavorite({
          memberId: this.sysUser.id,
          objectId: this.hospitail.id,
          objectType: 1,
        });
        this.initHospital();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 911px;
  box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
  border-radius: 10px;
  padding: 25px 21px;
  .hospital {
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    .hospitalImg {
      width: 339px;
      height: 196px;
      margin-right: 26px;
      border-radius: 6px;
      overflow: hidden;
      img {
        height: 196px;
      }
    }

    .detail {
      width: calc(100% - 375px);
      .name {
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        margin-right: 10px;
      }
      .tags {
        width: 100%;
        flex-wrap: wrap;
        margin-top: 6px;
        margin-bottom: 15px;
        .tag {
          border-radius: 10px;
          padding: 7px 12px;
          line-height: 1;
          font-size: 14px;
          color: #ffffff;
          background: #0079fe;
        }
        .tag:not(:last-child) {
          margin-right: 19px;
        }
      }
      .mobile {
        width: 100%;
        margin-top: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        span {
          margin-left: 15px;
        }
      }
      .more {
        font-size: 14px;
        width: calc(100% - 80px);
        position: relative;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          color: blue;
          position: absolute;
          top: 0;
          right: -2em;
          cursor: pointer;
        }
      }
    }
    .attention {
      cursor: pointer;
      line-height: 1;
      border: 1px solid #dcdcdc;
      border-radius: 8px;
      padding: 8px 6px;
      height: 34px;
      /deep/ .anticon {
        margin-right: 6px;
        font-size: 16px;
        color: #999;
      }
      .active {
        color: #d81e06;
      }
      span {
        display: inline-block;
        white-space: nowrap;
      }
    }
  }
  .depts {
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      padding-top: 25px;
    }
    .dept_name {
      cursor: pointer;
      .ant-col {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 400;
        color: #0079fe;
        div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .people {
          width: 100px;
        }
        .tag {
          // margin-left: 25px;
          max-width: 80px;
          border-radius: 10px;
          padding: 6px 12px;
          line-height: 1;
          font-size: 14px;
          color: #ffffff;
          background: #0079fe;
          margin-left: 12px;
        }
      }
    }
  }
  .evaluate {
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      padding: 25px 0;
      span {
        font-size: 20px;
        color: #666666;
      }
    }
    .evaluate_demo {
      padding-bottom: 20px;
      .photo {
        border: 1px solid #0079fe;
        width: 62px;
        height: 62px;
        border-radius: 50%;
        margin-right: 20px;
        overflow: hidden;
      }
      .demo_right {
        color: #666666;
        font-size: 18px;
        width: calc(100% - 82px);
        .tags {
          margin-left: 20px;
        }
      }
    }
    .evaluate_demo:not(:last-child) {
      border-bottom: 2px solid #f6f6f6;
    }
    .evaluate_demo:not(:first-child) {
      padding-top: 20px;
    }
  }
}
.hp_space_between {
  justify-content: flex-start !important;
}
</style>
